// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__S_m26","row":"styles_row__2qyx_"};